import { Col, Row } from "react-bootstrap";
import V1White from "../../../public/icons/v1_white.svg";
import HtmlParser from "../../utilities/HTMLParser";
import { prepositions } from "../../../libs/prepositons";
import classNames from "classnames";
import classes from "./WantedItem.module.scss";
import { ComponentPropsWithoutRef, useState } from "react";
import { useTranslation } from "next-i18next";

interface Props extends ComponentPropsWithoutRef<"div"> {
  position: string;
  requirements: string;
  advantages: string;
}

const WantedItem = ({
  className,
  position,
  requirements,
  advantages,
  ...htmlProps
}: Props) => {
  const { t } = useTranslation("career");

  return (
    <Col className={classNames("mb-7")} xs={12}>
      <div {...htmlProps} className={classNames(classes.wantedItem, className)}>
        <h2
          className={classes.wantedItem__position}
        >
          {position}
        </h2>
        <div className="position-relative">
          <div className={classes.wantedItem__line} />
          <div
            className={classes.wantedItem__opened}
          >
            <Row className="mb-3 gx-10">
              <Col xs={12} md={6} className="md-5 md-md-0">
                <h3
                  className={classes.wantedItem__title}
                >
                  {t("job_offers.requirements")}
                </h3>
                <HtmlParser
                  className="text-center text-sm-start"
                  html={prepositions(requirements)}
                />
              </Col>
              <Col xs={12} md={6}>
                <h3
                  className={classes.wantedItem__title}
                >
                  {t("job_offers.pluses")}
                </h3>
                <HtmlParser
                  className=" text-center text-sm-start"
                  html={prepositions(advantages)}
                />
              </Col>
            </Row>
          </div>
        </div>

        <div className={classes.wantedItem__icon}>
          <V1White />
        </div>
      </div>
    </Col>
  );
};

export default WantedItem;
